const stripSlug = slug => (slug ? slug.split('#')[0] : '');

export default stripSlug;
